import { Row, Button } from "react-bootstrap";
import { BUTTON_STYLES } from "./TransactionUtils";
import { Action } from "../../../common/constants/CommonConstants";

export const NavigationButtons = ({
  currentKey,
  maxTabs,
  isBtnDisabled,
  originalAction,
  onNext,
  onTemp
}) => {
  return (
    <Row style={{ padding: "5px 90px" }}>
      <div>
        <Button
          size="sm"
          variant="outline-primary"
          className="me-2"
          style={{
            display: currentKey === 1 ? "none" : "  ",
            ...BUTTON_STYLES,
          }}
          onClick={(e) => onTemp(e, "prev")}
          disabled={isBtnDisabled}
        >
          Prev
        </Button>
        <Button
          size="sm"
          className="float-end  me-2 btn-primary"
          onClick={(e) => onNext(e)}
          style={BUTTON_STYLES}
          disabled={isBtnDisabled}
        >
          {currentKey === maxTabs ? "Done" : "Next"}
        </Button>
        {originalAction !== Action.ActionAdd ? (
          ""
        ) : (
          <Button
            size="sm"
            variant="outline-primary "
            className="float-end  me-2"
            onClick={(e) => onTemp(e, "next")}
            style={BUTTON_STYLES}
            disabled={isBtnDisabled}
          >
            Temp Save
          </Button>
        )}
      </div>
    </Row>
  );
};